import React, { createContext, useState, useEffect } from "react";
import { getMe } from "api/coreApi";

interface UserContextType {
  host_id: number;
  host_name: string;
  user_id: number;
  email: string;
  firstName: string;
  lastName: string;
}

export const UserContext = createContext<UserContextType | null>(null);

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<UserContextType | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      const data = await getMe();

      setUser({
        host_id: data.host_id,
        host_name: data.host_name,
        user_id: data.user_id,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
      });
    };

    fetchUser();
  }, []);

  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
};
